export interface AcademicSessionOption {
  value: string;
  label: string;
}

/**
 * Generates dynamic academic session options starting from 2025/2026 up to (currentYear + 1).
 * e.g., if startYear is 2025 and current year is 2025/2026, generates 2025/2026 and 2026/2027.
 */
export function generateAcademicSessions(startYear = 2025): AcademicSessionOption[] {
  const currentYear = new Date().getFullYear();
  const endYear = Math.max(currentYear, startYear + 1);
  const sessions: AcademicSessionOption[] = [];

  for (let year = startYear; year <= endYear; year++) {
    const sessionStr = `${year}/${year + 1}`;
    sessions.push({
      value: sessionStr,
      label: `${sessionStr} Session`,
    });
  }

  return sessions;
}

/**
 * Calculates current term in the Nigerian Educational System based on date:
 * - 1st Term: September to December (Months 9-12) -> returns 1
 * - 2nd Term: January to April (Months 1-4) -> returns 2
 * - 3rd Term: May to August (Months 5-8) -> returns 3
 */
export function getCurrentAcademicTerm(date: Date = new Date()): number {
  const month = date.getMonth() + 1;
  if (month >= 9 && month <= 12) {
    return 1;
  } else if (month >= 1 && month <= 4) {
    return 2;
  } else {
    return 3;
  }
}

/**
 * Calculates current academic session in format YYYY/YYYY based on date:
 * - September to December: e.g. Sept 2026 -> "2026/2027"
 * - January to August: e.g. August 2026 -> "2025/2026"
 */
export function getCurrentAcademicSession(date: Date = new Date()): string {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  if (month >= 9) {
    return `${year}/${year + 1}`;
  } else {
    return `${year - 1}/${year}`;
  }
}
